export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export async function wait(ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function check_objects_are_the_same(o1, o2) {
  const entries1 = Object.entries(o1);
  const entries2 = Object.entries(o2);
  if (entries1.length !== entries2.length) {
    return false;
  }
  for (let i = 0; i < entries1.length; ++i) {
    // Keys
    if (entries1[i][0] !== entries2[i][0]) {
      return false;
    }
    // Values
    if (entries1[i][1] !== entries2[i][1]) {
      return false;
    }
  }

  return true;
}

export function mq(size) {
  const sizes = {
    phones: 30,
    tablet: 48,
    lg_tablet: 53,
    desktop: 62,
    lg_desktop: 75,
    widescreen: 90,
    lg_widescreen: 100,
  };

  const { matches } = window.matchMedia(`(min-width: ${sizes[size]}em)`);
  return matches;
}

export function prefersReducedMotion() {
  const { matches } = window.matchMedia(`(prefers-reduced-motion)`);
  return matches;
}

export function toggle_links_tabbable(links) {
  links.forEach((link) => {
    if (link.getAttribute("tabindex")) {
      link.removeAttribute("tabindex");
    } else {
      link.setAttribute("tabindex", "-1");
    }
  });
}

export function make_elements_tabbable(els) {
  els.forEach((el) => {
    el.setAttribute("tabindex", 0);
  });
}

export function make_elements_untabbable(els) {
  els.forEach((el) => {
    el.setAttribute("tabindex", "-1");
  });
}
